import { Button } from "PFComponents/button";
import { Icon } from "PFComponents/icon";
import PropTypes from "prop-types";
import React from "react";

import css from "./spinner.less";

const Spinner = ({ exportableProfiles, index, changeIndex }) => {
  const count = exportableProfiles.countEnabled();
  const canNext = index < count - 1;
  const canPrev = 0 < index;

  if (count <= 1) {
    return false;
  }

  return (
    <div className={css.root}>
      <Button
        kind="secondary"
        disabled={!canPrev}
        onClick={canPrev ? () => changeIndex(index - 1) : null}
        style={{ paddingLeft: 0, paddingRight: 0, width: 40 }}
      >
        <Icon name="chevron-left" size="sm" />
      </Button>

      <span className={css.text}>{`${index + 1} / ${count}`}</span>

      <Button
        kind="secondary"
        disabled={!canNext}
        onClick={canNext ? () => changeIndex(index + 1) : null}
        style={{ paddingLeft: 0, paddingRight: 0, width: 40 }}
      >
        <Icon name="chevron-right" size="sm" />
      </Button>
    </div>
  );
};

Spinner.propTypes = {
  exportableProfiles: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  changeIndex: PropTypes.func.isRequired
};

export default Spinner;
